import { SxProps, Theme } from "@mui/system";
import colors from "../../theme/Colours";

export const columnStyles = {
  labelStyle: {
    color: colors.paginationCaption,
    fontWeight: 500,
    fontSize: ["10px", "18px"],
    "&.MuiTableCell-root ": {
      paddingY: ["11px", "27px"],
      paddingX: ["0px", "11px"],
    },
  },
  cellStyle: {
    "&.MuiTableCell-root ": {
      paddingX: "0px",
    },
    fontSize: ["10px", "16px"],
    paddingY: ["11px", "26px"],
    paddingX: ["0px", "11px"],
  },
};

export const actionButtonStyle = (isMobile: boolean): SxProps<Theme> => ({
  width: isMobile ? "80px" : "131.22px",
  height: isMobile ? "24px" : "29px",
  padding: isMobile ? "2px 8px" : "4px 12px",
  fontSize: isMobile ? "8px" : "14px",
  gap: "10px",
  borderRadius: "60px",
  border: "1px solid #333333",
  backgroundColor: "#E9E9E9",
  "&.MuiButton-contained": {
    borderWidth: "1px",
  },
  color: "#000",
});

export const filterContainer: SxProps<Theme> = {
  cursor: "pointer",
  fontSize: "16px",
  background: "#f9fbff",
  borderRadius: "8px",
  padding: "10px 14px",
  minWidth: "70px",
  boxShadow: "0px 4px 4px 0px  #00000040",
  height: "38px",
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
};

export const paginationContainerStyle: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: "12px",
  backgroundColor: colors.background2,
  padding: "12px 24px",
  border: `1px solid ${colors.ledgerCustomerPaginationBox}`,
  borderRadius: "8px",
};

export const paginationCaptionStyle: SxProps = {
  color: colors.paginationCaption,
  fontFamily: "Poppins, sans-serif",
  fontWeight: 500,
};

export const statusSelectStyle: SxProps = {
  ...filterContainer,
  minWidth: "160px",
  "& .MuiSelect-select": {
    padding: "8px 12px",
    fontSize: "14px",
    fontWeight: 500,
    color: "#000",
  },
  "& .MuiSvgIcon-root": {
    right: 10,
  },
};

export const statusMenuItemStyle: SxProps = {
  fontSize: "14px",
};

export const statusRenderValueStyle: SxProps = {
  fontSize: "13px",
};

export const filterBoxStyle: SxProps = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "30px",
};

export const actionButtonsContainerStyle: SxProps = {
  display: "flex",
  gap: 1.5,
};

export const downloadButtonStyle: SxProps = {
  height: 32,
  marginTop: 4,
  marginLeft: 8,
  cursor: "pointer",
};

export const preBookingsTableContainerSx = {
  overflow: "visible",
};
